export default __webpack_public_path__ + "static/media/property_298.49397c85.png";